/**
 * The learner's marker: a small ringed dot centered on the place, or on the point along the
 * journey line, in screen px at every map zoom. It carries no name (the place keeps its own map
 * label) and is drawn beneath the names, so it never hides a neighbor's label.
 */
export const CHINA_MAP_LOCATION_MARKER = {
  /** The colored center. */
  radius: 4,
  /** The light ring around the center, which sets it apart from borders and land. */
  ringWidth: 1.5,
} as const;

/** A tap this close to the marker, in screen px, is on it: a 44 pt target around the small dot. */
export const CHINA_MAP_LOCATION_MARKER_HIT_RADIUS = 22;

/**
 * Whether a tap at `point` lands on the marker at `marker`, both in map coordinates. `scale` is
 * screen px per map unit, so the target keeps its screen size at every zoom.
 */
export function isChinaMapLocationMarkerHit(
  marker: readonly [number, number],
  point: readonly [number, number],
  scale: number,
) {
  return (
    Math.hypot(point[0] - marker[0], point[1] - marker[1]) * scale <=
    CHINA_MAP_LOCATION_MARKER_HIT_RADIUS
  );
}
